import * as React from 'react';

const TableFooter = React.forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => {
    return <tfoot ref={ref} {...props} />;
  },
);

TableFooter.displayName = 'TableFooter';

export { TableFooter };
